<template>
    <BCard>
        <ValidationObserver ref="form" #default="{ invalid }">
            <BForm @submit.prevent="onSubmit">
                <BRow>
                    <TextInputValidated vsName="Name" :vsModel.sync="tax.name" vsLabel="name" vsMd="4" vsRequired vsRules="required" />
                    <NumberInputValidated vsName="Value (%)" :vsModel.sync="tax.value" vsLabel="value" vsStep="0.01" vsMd="4" vsRequired vsRules="required" />
                    <NumberInputValidated vsName="Sucharge equivalence (%)" :vsModel.sync="tax.equivalence" vsStep="0.01" vsLabel="equivalence" vsMd="4" vsRequired vsRules="required"/>
                </BRow>
                <BButton variant="primary" class="mt-3 mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="onSubmit"> {{ $t("Save Changes") }} </BButton>
                <BButton variant="outline-secondary" class="mt-4" type="reset" :to="{ name:'taxes' }" :block="$store.getters['app/currentBreakPoint'] === 'xs'"> {{$t('Cancel')}} </BButton>
            </BForm>
        </ValidationObserver>
    </BCard>
</template>

<script>
import { BButton, BForm, BRow, BCol, BFormInput, BFormGroup, BCard } from 'bootstrap-vue'
import { onUnmounted, ref } from '@vue/composition-api';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import NumberInputValidated from '@/components/forms/NumberInputValidated.vue';
import TextInputValidated from '@/components/forms/TextInputValidated.vue';
import formValidation from '@core/comp-functions/forms/form-validation';
import taxModule from '../taxModule';
import popups from '@/hooks/popups';
import store from '@/store';

export default {
    components: { BButton, BForm, BRow, BCol, BFormInput, BFormGroup, ValidationObserver, ValidationProvider, BCard, TextInputValidated, NumberInputValidated },
    setup(){
        const { getValidationState } = formValidation()
        const { errorToast } = popups()
        const TAX_MODULE = 'taxes'
        const tax = ref({
            name: '',
            value: '',
            equivalence: '',
        })

        if(!store.hasModule(TAX_MODULE)) store.registerModule(TAX_MODULE, taxModule)

        onUnmounted(() => {
            if(store.hasModule(TAX_MODULE)) store.unregisterModule(TAX_MODULE)
        })

        const onSubmit = function() {
            this.$refs.form.validate().then(success => {
                if(success){
                    store.dispatch('taxes/addTax', JSON.parse(JSON.stringify(tax.value)))
                        .then(response => { this.$router.push({ name: 'taxes' }) })
                        .catch(error => { errorToast('Can\'t update taxes') })
                }
            })
        }

        return {
            getValidationState,
            errorToast,
            onSubmit,
            tax
        }
    }
}
</script>

<style>

</style>